export default ({ data: { order } }) => {
  return {
    editorBlocksOrder: order,
    editorHeaderStatus: 'saving',
    editorIsBlockMoveView: false
  };
};
